<xp-loading *ngIf="isLoadingOverlay" class="loading-overlay" [overlay]="true" [diameter]="48"></xp-loading>
<div class="flex justify-content-center">
    <div>
        <div class="login-form" data-testid="operator-login">
            <div class="flex">
                <img class="login-imglogo" src="../Content/xpress-app/images/operator/xpress_logo_operators.svg" />
                <div class="partner-portal mt-3 ml-2" *ngIf="app.merchantLogin">Partner Portal</div>
            </div>

            <div *ngIf="loginForm === LoginForm.Base" class="login-body">
                <div class="login-block-title mb-4">
                    <div class="mb-2 login-title">Welcome Back!</div>
                    <div class="login-subtitle">Please log into your account.</div>
                </div>

                <div *ngIf="credentialsError" class="credentials-error" role="alert" data-testid="operator-login-credentials-error">
                    <mat-icon class="credentials-error-icon">error_outline</mat-icon>
                    <span>{{ credentialsError }}</span>
                </div>

                <mat-form-field #usernameField appearance="outline" class="w-100"
                                [class.login-field--error]="!!credentialsError && !usernameBlankHighlight && !usernameFieldBlink"
                                [class.login-field--blank]="usernameBlankHighlight || usernameFieldBlink"
                                subscriptSizing="dynamic">
                    <mat-label>Username</mat-label>
                    <input matInput type="text" data-testid="operator-login-username"
                           [(ngModel)]="usernameValue" [errorStateMatcher]="usernameErrorMatcher" (input)="onUsernameInput()" />
                    <mat-error *ngIf="usernameError">{{ usernameError }}</mat-error>
                </mat-form-field>

                <div class="password-field-header flex">
                    <a class="pass-forgot" data-testid="operator-forgot-password" (click)="openForgotPassword()">Forgot Password?</a>
                </div>
                <xp-password-field #password
                                   class="w-100"
                                   [class.login-field--error]="!!credentialsError && !passwordBlankHighlight && !passwordFieldBlink"
                                   [class.login-field--blank]="passwordBlankHighlight || passwordFieldBlink"
                                   label="Password"
                                   inputTestId="operator-login-password"
                                   [(value)]="passwordValue"
                                   (valueChange)="onPasswordInput()"
                                   [errorText]="passwordError || ''"
                                   [showError]="!!passwordError"></xp-password-field>

                <mat-checkbox #rememberMe class="remember-me-checkbox">Remember me</mat-checkbox>

                <div class="flex mt-1 w-100 login-actions">
                    <button *ngIf="isOperatorPortal" mat-stroked-button type="button" class="operator-btn signup-btn" (click)="goToSignUp()">Sign Up</button>
                    <button mat-flat-button type="button" color="primary" class="operator-btn login-btn" (click)="login()">Login</button>
                </div>
            </div>

            <div *ngIf="loginForm === LoginForm.ResetPassword" class="login-body h-fit">
                <xp-back-button class="mt-3 back-to-login-btn"
                                iconSrc="../Content/xpress-app/images/operator/signup/arrow-left.svg"
                                (click)="switchLoginForm(LoginForm.Base)">Back to Log In</xp-back-button>

                <div class="login-block-title mt-4 mb-4">
                    <div class="mb-2 mt-2 login-title">Password Reset</div>
                    <div class="login-subtitle" *ngIf="isOperatorPortal">Enter the email address for your operator account</div>
                    <div class="login-subtitle" *ngIf="!isOperatorPortal">Enter your email address below to recover your password</div>
                </div>

                <div *ngIf="isOperatorPortal && emailError" class="credentials-error" role="alert" data-testid="operator-recovery-email-error">
                    <mat-icon class="credentials-error-icon">error_outline</mat-icon>
                    <span>{{ emailError }}</span>
                </div>

                <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic"
                                [class.login-field--error]="recoveryEmailInvalid">
                    <mat-label>Email</mat-label>
                    <input matInput type="email" name="recoveryEmail" data-testid="operator-recovery-email"
                           [(ngModel)]="recoveryEmail" (ngModelChange)="onRecoveryEmailInput()" (focusout)="validateEmail()" />
                    <mat-error *ngIf="emailError && !isOperatorPortal">{{ emailError }}</mat-error>
                </mat-form-field>

                <div class="flex mt-1 w-100">
                    <button *ngIf="isOperatorPortal" mat-flat-button type="button" color="primary"
                            class="operator-btn login-btn w-100" data-testid="operator-send-otp"
                            [disabled]="!recoveryEmail.trim()" (click)="sendPasswordResetOtp()">Send OTP</button>
                    <button *ngIf="!isOperatorPortal" mat-flat-button type="button" color="primary"
                            class="operator-btn login-btn w-100"
                            [disabled]="!validateEmail()" (click)="submitReset()">Submit</button>
                </div>
            </div>

            <div *ngIf="loginForm === LoginForm.ResetSent" class="login-body h-fit">
                <xp-back-button class="mt-3 back-to-login-btn"
                                iconSrc="../Content/xpress-app/images/operator/signup/arrow-left.svg"
                                (click)="switchLoginForm(LoginForm.Base)">Back to Log In</xp-back-button>

                <div class="login-block-title mt-4 mb-4">
                    <div class="mb-2 login-title">We sent you an E-mail</div>
                    <div class="login-subtitle">We've sent a link to your registered email address.
                                                Click on it to proceed with changing your password
                    </div>
                </div>
            </div>

            <div *ngIf="loginForm === LoginForm.OTPSent || loginForm === LoginForm.ResetOtp" class="login-body otp-login-body"
                 [attr.data-testid]="loginForm === LoginForm.ResetOtp ? 'operator-reset-otp' : null">
                <xp-back-button *ngIf="loginForm === LoginForm.ResetOtp"
                                class="back-to-login-btn"
                                iconSrc="../Content/xpress-app/images/operator/signup/arrow-left.svg"
                                (click)="switchLoginForm(LoginForm.ResetPassword)">Back</xp-back-button>
                <div class="login-block-title mt-4 mb-4">
                    <div class="mb-2 login-title">{{ loginForm === LoginForm.ResetOtp ? 'Enter the password-reset code' : "We've sent you an OTP to your email." }}</div>
                    <div class="login-subtitle" *ngIf="loginForm === LoginForm.ResetOtp" data-testid="operator-reset-masked-email">We sent a six-digit code to {{ maskedRecoveryEmail }}. It expires in 10 minutes. You can paste the complete code.</div>
                    <div class="login-subtitle" *ngIf="loginForm !== LoginForm.ResetOtp">Please enter the OTP below to verify your account.
                        If you didn't receive the email, check your spam folder or request a new OTP.
                    </div>
                </div>

                <xp-otp-input [invalid]="otpInputError"
                              [disabled]="isOtpInputLocked"
                              [(value)]="otpValue"
                              (completed)="checkOneTimePassword(sendOTPProcessId, $event)"></xp-otp-input>
                <xp-message *ngIf="wrongOtpAttemptCount !== 3 && otpError" class="otp-error mg-auto" severity="error" [plain]="true">{{ otpError }}</xp-message>
                <xp-message *ngIf="wrongOtpAttemptCount === 3 && loginForm === LoginForm.ResetOtp" class="otp-error mg-auto" severity="error" [plain]="true">
                    {{ otpError || 'Too many incorrect codes. Request a new OTP or return to log in.' }}
                </xp-message>
                <xp-message *ngIf="wrongOtpAttemptCount === 3 && loginForm !== LoginForm.ResetOtp"
                            class="lm-active-order-details-canceled-block mg-auto text-center"
                            severity="error"
                            [plain]="true">
                    You have entered the OTP incorrectly 3 times. For your security, your session has been temporarily locked. Please try again after {{secondsOtpBlock}} seconds.
                </xp-message>

                <div class="flex mt-1 w-100">
                    <button mat-stroked-button type="button" class="operator-btn resend-otp-btn w-100"
                            [disabled]="secondsToResend > 0" (click)="resendOTP()">
                        Resend ({{secondsToResend}} secs)
                    </button>
                </div>
            </div>

            <div *ngIf="loginForm === LoginForm.ResetSession" class="login-body h-fit" data-testid="operator-password-reset-session">
                <xp-back-button class="mt-3 back-to-login-btn"
                                iconSrc="../Content/xpress-app/images/operator/signup/arrow-left.svg"
                                (click)="switchLoginForm(LoginForm.Base)">Back to Log In</xp-back-button>
                <div class="login-block-title mt-4 mb-4">
                    <div class="mb-2 login-title">Create a new password</div>
                    <div class="login-subtitle">This reset session can only be used to set a new password.</div>
                </div>
                <p class="password-rules">Use at least 8 characters, with one uppercase letter, one lowercase letter, one number, and one special character.</p>
                <div *ngIf="passwordResetError" class="credentials-error" role="alert" data-testid="operator-new-password-error">
                    <mat-icon class="credentials-error-icon">error_outline</mat-icon><span>{{ passwordResetError }}</span>
                </div>
                <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                    <mat-label>New Password</mat-label>
                    <input matInput [type]="showNewPassword ? 'text' : 'password'" name="newPassword" data-testid="operator-new-password" [(ngModel)]="newPassword" (ngModelChange)="passwordResetError = null" autocomplete="new-password" />
                    <button mat-icon-button matSuffix type="button" (click)="showNewPassword = !showNewPassword" [attr.aria-label]="showNewPassword ? 'Hide password' : 'Show password'"><mat-icon>{{ showNewPassword ? 'visibility' : 'visibility_off' }}</mat-icon></button>
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                    <mat-label>Confirm Password</mat-label>
                    <input matInput [type]="showConfirmPassword ? 'text' : 'password'" name="confirmPassword" data-testid="operator-confirm-password" [(ngModel)]="confirmPassword" (ngModelChange)="passwordResetError = null" autocomplete="new-password" />
                    <button mat-icon-button matSuffix type="button" (click)="showConfirmPassword = !showConfirmPassword" [attr.aria-label]="showConfirmPassword ? 'Hide password' : 'Show password'"><mat-icon>{{ showConfirmPassword ? 'visibility' : 'visibility_off' }}</mat-icon></button>
                </mat-form-field>
                <div *ngIf="passwordsDoNotMatch" class="credentials-error" role="alert" data-testid="operator-password-mismatch">
                    <mat-icon class="credentials-error-icon">error_outline</mat-icon><span>Passwords must match.</span>
                </div>
                <button mat-flat-button type="button" color="primary" class="operator-btn login-btn w-100" data-testid="operator-reset-password"
                        [disabled]="!canResetPassword || isLoadingOverlay" (click)="submitNewPassword()">Reset Password</button>
            </div>

        </div>
        <div class="login-page-build-number">Xpress {{portalType}}'s Portal Version {{buildNumber}}</div>
    </div>
    <div *ngIf="isOperatorPortal" class="carousel mt-5">
        <input type="radio" #slide1 name="slides" id="slide-1">
        <input type="radio" #slide2 name="slides" id="slide-2">
        <input type="radio" #slide3 name="slides" id="slide-3">
        <input type="radio" #slide4 name="slides" id="slide-4">
        <ul class="carousel__slides">
            <li class="carousel__slide">
                <figure>
                    <div>
                        <img src="../Content/xpress-app/images/car-driver.png"/>
                    </div>
                </figure>
            </li>
            <li class="carousel__slide">
                <figure>
                    <div>
                        <img src="../Content/xpress-app/images/moto-driver.png"/>
                    </div>
                </figure>
            </li>
            <li class="carousel__slide">
                <figure>
                    <div>
                        <img src="../Content/xpress-app/images/car-driver2.png"/>
                    </div>

                </figure>
            </li>
            <li class="carousel__slide">
                <figure>
                    <div>
                        <img src="../Content/xpress-app/images/moto-driver2.png"/>
                    </div>
                </figure>
            </li>
        </ul>
        <ul class="carousel__thumbnails">
            <li>
                <label for="slide-1"></label>
            </li>
            <li>
                <label for="slide-2"></label>
            </li>
            <li>
                <label for="slide-3"></label>
            </li>
            <li>
                <label for="slide-4"></label>
            </li>
        </ul>
    </div>

    <img *ngIf="app.merchantLogin || app.tourOperatorLogin" class="merchant-imglogo" src="../Content/xpress-app/images/partner-login.svg" />
</div>
